// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class EscalationData {
  header: string;
  escalationEnabled: boolean;
  escalationStartDate: Date;
  estimateStartDate: Date;
  firstYearPercentage: number;
  secondYearPercentage: number;
  thirdYearPercentage: number;
  fourthYearPercentage: number;
  fifthYearPercentage: number;
  secondYearRate: number;
  thirdYearRate: number;
  fourthYearRate: number;
  fifthYearRate: number;
  baseCost: number;
  escalatedCost: number;
  actualBaseCost: number;
  previousEscalatedCost: number;
}
